import * as Styles from "./style.js";

export const Tags = (props) => {
  return (
    <Styles.Main onClick={props.onClick}>
      <Styles.Text>{props.title}</Styles.Text>
    </Styles.Main>
  );
};
